import React, { useState } from 'react';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';

import AppointmentModal from './AppointmentModal';
import { Page } from './styles';

const localizer = momentLocalizer(moment);

const CalendarComponent = ({
  defaultView,
  views,
  appointments,
  components,
  date,
  fetchAppointments,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState();
  const [, setView] = useState(defaultView || 'month');

  const onSelectEvent = (event) => {
    setSelectedAppointment(event);
    setModalOpen(true);
  };

  const onView = (e) => {
    setView(e);
  };

  const AppointmentTitle = (appointment) => {
    const { resources } = appointment;
    const {
      timeSlot,
      fullName,
      service: { serviceName },
    } = resources;

    return `${timeSlot} / ${fullName} / ${serviceName}`;
  };

  return (
    <Page>
      <AppointmentModal
        appointment={selectedAppointment}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        fetchAppointments={fetchAppointments}
      />

      <Calendar
        localizer={localizer}
        events={appointments || []}
        startAccessor="start"
        endAccessor="end"
        onSelectEvent={onSelectEvent}
        titleAccessor={AppointmentTitle}
        popup
        popupOffset={50}
        defaultView={defaultView}
        views={views}
        showMultiDayTimes
        date={date}
        onView={onView}
        components={components}
      />
    </Page>
  );
};
export default CalendarComponent;
